// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3Yig0","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__J1sy3"};